import { Layout } from 'antd';
import { Content } from 'antd/lib/layout/layout';

import React from "react";
import OAMSider from '../oam-sider';

export interface Props {}

/** OAM 章节预览 */
export const OAMChapterDetail: React.FC<Props> = (props) => {

    return (
        <Layout style={{ minHeight: '100vh' }}>
        <OAMSider keys={"4"} openKeys={["sub-project"]} ></OAMSider>
        <div>
            <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:1000,margin:30 ,paddingTop:20}}>
                我是oam章节预览页
            </Content>
        </div>
    </Layout>
    )

}

export default OAMChapterDetail

